import { NextSeo } from 'next-seo';
import { Fragment } from 'react';

import { TeamContainer } from '@/components/ui/features/team/TeamContainer/TeamContainer';
import { TeamHeader } from '@/components/ui/features/team/TeamHeader/TeamHeader';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';

const Team = () => {
  return (
    <Fragment>
      <NextSeo
        title="Underline Team"
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/team`,
        }}
      />
      <Layout navigationVariant="default">
        <TeamHeader />
        <TeamContainer />
      </Layout>
    </Fragment>
  );
};

export default Team;
